module.exports = __webpack_public_path__ + "img/apps.4501a0e3.svg";